import React, { useEffect, useState } from 'react';
import { AddCreditCardForm } from 'src/pages/AccountPage/components/AddCreditCardForm';
import { Modal } from '@riac/design-system';
import { useFetch } from 'src/lib/FetchContext';

export const AddCardModal = ({ onConfirm, onReject }) => {
  const { fetch } = useFetch();
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    fetchData().then();
  }, []);

  const fetchData = async () => {
    const countryResults = await (await fetch('/api/account/creditcard/getCountries')).json();
    setCountries(countryResults);
  };

  return (<Modal
    title='Add New Card'
    isOpen={true}
    onClose={() => {onReject(false);}}
    showCloseButton
  >
    <div style={{ width: '100%', maxWidth: '540px', maxHeight: '750px' }}>
      <h5 className='my-4 text-red-700'>Credit Card required for RIAC on Time</h5>
      <p className='mb-4 text-zinc-700'>Please enter your credit card information below.</p>
      <p className='mb-4 text-zinc-700'>
        Rock Island Auction utilizes a third party payment gateway system that processes credit
        card transactions in real-time using industry standard security practices. Rock Island
        Auction does not save your credit card number, but we do store the last 4 digits, the
        expiration date and a token to help identify this payment information at the credit
        card processor whom secures your card information.
      </p>
      <AddCreditCardForm countries={countries} handleCancel={onReject} onAddCard={() => {
        onConfirm(true);
      }}/>
    </div>
  </Modal>);
};
